<p>
  kpis-admin works!
</p>
